export default "__VITE_ASSET__Kx$TJX4d__"